<script setup lang="ts">
import { useWebSocket } from '@vueuse/core';
import { type PropType, watch } from 'vue';
import { useInfiniteScroll } from '~/composables/infinite-scroll';
import { getApiRoot } from '~/utilities/api';

const props = defineProps({
  collection: Object as PropType<any>,
});
const { collection } = toRefs(props);

const bottom = ref();
const { items: events } = useInfiniteScroll(bottom, () => `${getApiRoot()}/events?collection=${collection.value.id}`);

if (process.client) {
  const config = useRuntimeConfig();

  const toTimestamp = (dateString: string): number => new Date(dateString).getTime();

  const { status, data } = useWebSocket(config.public.eventsWebsocketUrl, {
    autoReconnect: true,
  });
  watch(data, () => {
    const newEvent = JSON.parse(data.value);
    console.log({ event: newEvent });
    if (newEvent.collection?.id === collection.value.id) {
      const oldestEvent = events.value[events.value.length - 1];
      if (toTimestamp(newEvent.timestamp) >= toTimestamp(oldestEvent.timestamp)) {
        events.value = [newEvent, ...events.value.filter((event) => event.id !== newEvent.id)].sort(
          (a, b) => toTimestamp(b.timestamp) - toTimestamp(a.timestamp)
        );
      }
    }
  });
  watch(status, () => {
    console.log({ status: status.value });
  });
}
</script>

<template>
  <div>
    <EventsTable :events="events" />
    <div ref="bottom"></div>
  </div>
</template>
